import { render } from "./Main.vue?vue&type=template&id=33e340a0"
const script = {}
script.render = render

export default script